export const GET_DIAGNOSIS = 'GET_DIAGNOSIS';
export const LOADING_DIAGNOSIS = 'LOADING_DIAGNOSIS';
export const SAVE_LOADER_DIAGNOSIS = 'SAVE_LOADER_DIAGNOSIS'
export const FORM_FAIL = "FORM_FAIL";
export const DIAGNOSIS_FAIL = 'DIAGNOSIS_FAIL';